import { apiClient } from "./client";

export interface AccountOutputSchema {
  id: string;
  locationName?: string; // Preferred field
  locationNames?: string[]; // Array of location names
  location_id?: string; // Legacy field, prefer locationName
  credit_limit: number;
  available_credit: number;
  status: "active" | "suspended";
  ssn: string | null;
  dob: string | null; // ISO date string
  zip: string | null;
  phone: string | null;
  createdAt?: string; // ISO datetime string (camelCase)
  created_at?: string; // ISO datetime string (snake_case)
  updatedAt?: string; // ISO datetime string (camelCase)
  updated_at?: string; // ISO datetime string (snake_case)
}

export interface AccountsListResponse {
  items: AccountOutputSchema[];
  total: number;
  offset: number;
  limit: number;
}

export interface AccountCreateSchema {
  location_id: string;
  credit_limit: number;
  available_credit: number;
  status: "active" | "suspended";
  ssn: string | null;
  dob: string | null;
  zip: string | null;
  phone: string | null;
}

export interface AccountUpdateSchema {
  creditLimit?: number | null;
  availableCredit?: number | null;
  status?: "active" | "suspended" | null;
}

export interface GetAccountsParams {
  status?: string | null;
  location_id?: string | null;
  offset?: number;
  limit?: number;
}

export const accountsApi = {
  getAccounts: async (params?: GetAccountsParams): Promise<AccountsListResponse> => {
    const response = await apiClient.get("/accounts/", { params });
    return response.data;
  },

  getAccount: async (accountId: string): Promise<AccountOutputSchema> => {
    const response = await apiClient.get(`/accounts/${accountId}`);
    return response.data;
  },

  createAccount: async (data: AccountCreateSchema): Promise<AccountOutputSchema> => {
    const response = await apiClient.post("/accounts/", data);
    return response.data;
  },

  updateAccount: async (
    accountId: string,
    data: AccountUpdateSchema
  ): Promise<AccountOutputSchema> => {
    const response = await apiClient.patch(`/accounts/${accountId}`, data);
    return response.data;
  },

  getAccountApplications: async (accountId: string) => {
    const response = await apiClient.get(`/accounts/${accountId}/applications`);
    return response.data;
  },
};
